import { useEffect, useState } from 'react';
import {
    getPromoById,
    getPromos,
    validatePromoPost
} from '../services/PromoService'

export const usePromo = () => {
    const [promo, setPromo] = useState([]);
    const [validatePromoState, setValidatePromoState] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const validatePromo = async (product) => {
        try {
            const response = await validatePromoPost(product);
            
            setValidatePromoState([...promo, response?.data?.data]);
            return response.data
        } catch {
            setError('Failed to add product');
        }
    };

    const fetchPromo = async () => {
        try {
            setLoading(true);
            const response = await getPromos();
            setPromo(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch Promo');
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    const fetchPromoById = async (id) => {
        try {
            const response = await getPromoById(id);
            setPromo(promo.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update Promo');
        }
    };

    useEffect(() => {
        fetchPromo();
    }, []);

    return {
        promo,
        loading,
        error,
        validatePromoState,
        validatePromo,
        alert,
        fetchPromo,
        fetchPromoById
    };
}